export const language = [
  {
    value: 'es',
    label: 'Spanish',
  },
  {
    value: 'en',
    label: 'English',
  },
];
